<template>
  <div class="row">
    <div class="col col-md-7 border rounded-3">
      <bildirim-card v-for="i in 10" :key="i" />
    </div>
    <sidefix />
  </div>
</template>
<script>
import Sidefix from "@/components/Shared/Sidefix.vue";
import BildirimCard from "@/components/Pages/Bildirimler/BildirimCard.vue";
export default {
  components: { Sidefix, BildirimCard },
};
</script>

<style></style>
